// The below two imports will be replaced by Babel by appropriate polyfills
// See babel config docs https://babeljs.io/docs/en/babel-preset-env#usebuiltins
import 'core-js/stable'
import './sentry'
import React from 'react'
import ReactDOM from 'react-dom/client'
import moment from 'moment-timezone'
import 'process/browser';

import {Root} from './Root'

window.moment = moment

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Root/>
)
